import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { ItemPurpose } from "./HeroBuilds";

// Подпись под иконкой предмета «по ситуации» — что он даёт, в 1–3 слова (доска «19д»).
// Код назначения приходит с бэкенда (`builds.catalog.ITEM_PURPOSES`).
export const ITEM_PURPOSE_LABEL: Record<ItemPurpose, MessageDescriptor> = {
  regen: msg({ id: "builds.purpose.regen", message: "regen" }),
  creep_damage: msg({ id: "builds.purpose.creep_damage", message: "creep damage" }),
  more_health: msg({ id: "builds.purpose.more_health", message: "more health" }),
  sprint: msg({ id: "builds.purpose.sprint", message: "sprint speed" }),
  more_souls: msg({ id: "builds.purpose.more_souls", message: "more souls" }),
  heal_on_shot: msg({ id: "builds.purpose.heal_on_shot", message: "heals on shot" }),
  melee_heal: msg({ id: "builds.purpose.melee_heal", message: "heals on melee" }),
  vs_bullets: msg({ id: "builds.purpose.vs_bullets", message: "vs bullets" }),
  vs_spirit: msg({ id: "builds.purpose.vs_spirit", message: "vs spirit" }),
  resist_all: msg({ id: "builds.purpose.resist_all", message: "vs all damage" }),
  barrier: msg({ id: "builds.purpose.barrier", message: "barrier" }),
  bullet_lifesteal: msg({ id: "builds.purpose.bullet_lifesteal", message: "bullet lifesteal" }),
  spirit_lifesteal: msg({ id: "builds.purpose.spirit_lifesteal", message: "spirit lifesteal" }),
  lifesteal: msg({ id: "builds.purpose.lifesteal", message: "lifesteal" }),
  health_regen: msg({ id: "builds.purpose.health_regen", message: "health and regen" }),
  self_heal: msg({ id: "builds.purpose.self_heal", message: "self-heal" }),
  healing_boost: msg({ id: "builds.purpose.healing_boost", message: "stronger healing" }),
  cleanse: msg({ id: "builds.purpose.cleanse", message: "cleanses debuffs" }),
  cc_immunity: msg({ id: "builds.purpose.cc_immunity", message: "immune to control" }),
  status_resist: msg({ id: "builds.purpose.status_resist", message: "shorter debuffs" }),
  bullet_immunity: msg({ id: "builds.purpose.bullet_immunity", message: "bullet immunity" }),
  invulnerability: msg({ id: "builds.purpose.invulnerability", message: "invulnerability" }),
  cheat_death: msg({ id: "builds.purpose.cheat_death", message: "cheats death" }),
  deflect_bullets: msg({ id: "builds.purpose.deflect_bullets", message: "deflects bullets" }),
  parry_abilities: msg({ id: "builds.purpose.parry_abilities", message: "parries abilities" }),
  low_health: msg({ id: "builds.purpose.low_health", message: "when low on health" }),
  anti_heal: msg({ id: "builds.purpose.anti_heal", message: "cuts healing" }),
  slow: msg({ id: "builds.purpose.slow", message: "slows" }),
  cut_bullet_resist: msg({ id: "builds.purpose.cut_bullet_resist", message: "cuts bullet resist" }),
  cut_spirit_resist: msg({ id: "builds.purpose.cut_spirit_resist", message: "cuts spirit resist" }),
  steal_health: msg({ id: "builds.purpose.steal_health", message: "steals health" }),
  disarm: msg({ id: "builds.purpose.disarm", message: "disarms" }),
  silence: msg({ id: "builds.purpose.silence", message: "silences" }),
  stun: msg({ id: "builds.purpose.stun", message: "stuns" }),
  pull: msg({ id: "builds.purpose.pull", message: "pulls enemies" }),
  cut_damage: msg({ id: "builds.purpose.cut_damage", message: "cuts enemy damage" }),
  cut_fire_rate: msg({ id: "builds.purpose.cut_fire_rate", message: "cuts fire rate" }),
  weapon_damage: msg({ id: "builds.purpose.weapon_damage", message: "weapon damage" }),
  damage_slow: msg({ id: "builds.purpose.damage_slow", message: "damage and slow" }),
  fire_rate: msg({ id: "builds.purpose.fire_rate", message: "fire rate" }),
  ammo: msg({ id: "builds.purpose.ammo", message: "ammo" }),
  bullet_speed: msg({ id: "builds.purpose.bullet_speed", message: "bullet speed" }),
  spirit_power: msg({ id: "builds.purpose.spirit_power", message: "spirit power" }),
  spirit_damage: msg({ id: "builds.purpose.spirit_damage", message: "spirit damage" }),
  close_range: msg({ id: "builds.purpose.close_range", message: "close range" }),
  long_range: msg({ id: "builds.purpose.long_range", message: "long range" }),
  headshots: msg({ id: "builds.purpose.headshots", message: "headshots" }),
  melee: msg({ id: "builds.purpose.melee", message: "melee" }),
  multi_target: msg({ id: "builds.purpose.multi_target", message: "hits several targets" }),
  cooldown: msg({ id: "builds.purpose.cooldown", message: "cooldown" }),
  duration: msg({ id: "builds.purpose.duration", message: "duration" }),
  range: msg({ id: "builds.purpose.range", message: "range" }),
  charges: msg({ id: "builds.purpose.charges", message: "charges" }),
  cooldown_reset: msg({ id: "builds.purpose.cooldown_reset", message: "cooldown reset" }),
  ability_boost: msg({ id: "builds.purpose.ability_boost", message: "empowers an ability" }),
  ultimate: msg({ id: "builds.purpose.ultimate", message: "for the ultimate" }),
  move_speed: msg({ id: "builds.purpose.move_speed", message: "move speed" }),
  dash: msg({ id: "builds.purpose.dash", message: "dash" }),
  teleport: msg({ id: "builds.purpose.teleport", message: "teleport" }),
  stamina: msg({ id: "builds.purpose.stamina", message: "stamina" }),
  stealth: msg({ id: "builds.purpose.stealth", message: "stealth" }),
  heal_allies: msg({ id: "builds.purpose.heal_allies", message: "heals allies" }),
  shield_allies: msg({ id: "builds.purpose.shield_allies", message: "shields allies" }),
  team_aura: msg({ id: "builds.purpose.team_aura", message: "buffs the team" }),
};
